import { render } from "./MitarbeiterList.vue?vue&type=template&id=e77ea17c"
import script from "./MitarbeiterList.vue?vue&type=script&lang=ts"
export * from "./MitarbeiterList.vue?vue&type=script&lang=ts"

import "./MitarbeiterList.vue?vue&type=style&index=0&id=e77ea17c&lang=scss"
script.render = render

export default script